import WalletBalance from './WalletBalance';
export default WalletBalance;
